import {
  List,
  ListItem,
  ListItemText,
  makeStyles,
  TextField,
} from "@material-ui/core";
import { useState } from "react";
import axios from "axios";
import { getSpotifyToken } from "../../controllers/apiController";
import {getState} from "../../controllers/stateController";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
  },
  textInput: {
    background: "white",
    color: "black",
    fontSize: "x-large",
    fontWeight: "bold",
  },
  img: {
    margin: theme.spacing(1),
    width: 40,
  },
  searchBar: {
    background: theme.palette.secondary.light,
  },
}));

function SearchResult({ track, handleSelect }) {
  const classes = useStyles();

  return (
    <ListItem
      id="search-result"
      alignItems="flex-start"
      onClick={() => handleSelect(track)}
      button
    >
      <img
        src={track.album.images[2].url}
        alt={"Album Cover"}
        className={classes.img}
      />
      <ListItemText
        primary={track.name}
        secondary={track.album.artists
          .map((artist) => {
            return artist.name;
          })
          .toString()}
      />
    </ListItem>
  );
}

function SearchBar({ createAlert }) {
  const classes = useStyles();

  const [searchResults, setSearchResults] = useState([]);
  const [currentInput, setCurrentInput] = useState("");

  // handle adding song to backlog
  const handleSelect = (track) => {
    // check user votes
    axios
      .post(global.API_URL + "/add-song", {
        token: getState().apiToken,
        songId: track.id,
      })
      .then(() => {
        // on api success
        createAlert(`${track.name} was added to the backlog.`, "success");
      })
      .catch((e) => {
        // on api failure
        createAlert(e.response.data, "error");
      });

    setSearchResults([]);
    setCurrentInput("");
  };

  const handleSearch = (e) => {
    // handle empty
    if (e.target.value === "") {
      setSearchResults([]);
    } else {
      axios
        .get("https://api.spotify.com/v1/search/", {
          params: {
            q: e.target.value,
            type: "track",
            market: "US",
            limit: 5,
          },
          headers: {
            Authorization: `Bearer ${getState().access_token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          setSearchResults(response.data.tracks.items);
        })
        .catch(function (error) {
          getSpotifyToken(null).catch((e) => {
            createAlert(
                "Could not connect to Spotify. Try leaving and rejoining the room.",
                "error"
            );
          });
        });
    }
  };

  return (
    <div className={`${classes.root} ${searchResults.length !== 0 ? classes.searchBar : null}`}>
      <TextField
        id="text-field"
        variant="outlined"
        style={{ width: "90%" }}
        type="search"
        InputLabelProps={{
          classes: {
            root: classes.textInput,
          },
        }}
        InputProps={{
          classes: {
            root: classes.textInput,
          },
        }}
        placeholder="REQUEST A SONG"
        onChange={(e) => {
          setCurrentInput(e.target.value);
          handleSearch(e);
        }}
        value={currentInput}
      />
      <List>
        {searchResults.map((track) => {
          return (
            <div key={track.id}>
              <SearchResult
                track={track}
                handleSelect={(e) => handleSelect(e)}
              />
            </div>
          );
        })}
      </List>
    </div>
  );
}

export default SearchBar;
